import script from "./CartProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./CartProducts.vue?vue&type=script&setup=true&lang=js"

import "./CartProducts.vue?vue&type=style&index=0&id=33692439&lang=css"

const __exports__ = script;

export default __exports__